export const translations = {
    en: {
        enterHints: "Write some hints about you",
        typeHints: "Type",
        uploadtitle: "Add your selfie hint",
        uploaddes1: "Upload your face pic",
        uploaddes2: "Image size upto 5 mb",
        popupTitle: "Upload face pic",
        cameraPermission: "Camera access denied.",
        cameraMSG: "Please capture your face",
        galleryMSG: "Please add your face",
        sizeError: "Image size exceeds 5MB. Please choose a smaller image.",
        detectionError: "No face detected in the image. Please upload an image with a clear visible face.",
        cancel: "Cancel",
        camera: "Camera",
        gallery: "Gallery",
        avatar: "Avatar",
        hinttext: "Text Hint",
        hintimage: "Selfie Hint",
        addselfie: "Add selfie",
        addImage: "Add Image",
        selectRelation: "Select a relation",
        cameraPermissionTitle: "Camera Permission Required",
        cameraPermissionDesc: "Please enable microphone permission from your browser settings.",
        cameraBlockedAndroid: "Camera permission is blocked. To enable:\n1. Tap the three dots (⋮) in browser\n2. Go to Site settings\n3. Tap Camera\n4. Select 'Allow'",
        cameraBlockedIOS: "Camera permission is blocked. Please enable it in your browser settings.",
        cameraDenied: "Camera access was denied",
        cameraNotSupported: "Camera is not supported on this device.",
        galleryNotSupported: "File access is not supported on this device.",
        steps: "Follow this step",
        cameraStep1: { text: "Tap the three dots", bold: "(⋮)", text2: "in browser" },
        cameraStep2: { text: "Go to", bold: "Site settings", text2: "" },
        cameraStep3: { text: "Allow", bold: "Camera", text2: "" },
        cameraStep4: { text: "Page", bold: "refresh", text2: "" },
        openInSafari: "Open in Safari",
        safariStep1: "Tap the Share button (square with arrow) at the bottom",
        safariStep2: "Scroll and tap \"Open in Safari\"",
        safariStep3: "Allow microphone access when prompted",
        openInChrome: "Open in Chrome",
        chromeStep1: "Tap the three dots (⋮) menu",
        chromeStep2: "Select \"Open in Chrome\" or \"Open in Browser\"",
        chromeStep3: "Allow microphone access when prompted",
        orCopyLink: "So copy link and paste other browser",
        follow: "Follow this step",
        gotIt: "Copy link",
        linkCopied: "Link Copied!",
        linkCopiedDesc: "You can now paste it in app browser",
        microtitle: "This browser doesn’t support microphone",
        microErrorInstagram: "Instagram's browser doesn't support microphone access. Please open in Safari or Chrome.",
        microErrorSnapchat: "Snapchat's browser doesn't support microphone access. Please open in Safari or Chrome.",
        microErrorFacebook: "Facebook's browser doesn't support microphone access. Please open in Safari or Chrome.",
        microErrorTelegram: "Telegram's browser doesn't support microphone access. Please open in Safari or Chrome.",
        microErrorDefault: "This app's browser doesn't support microphone access.",
        contentApiFail: "Content not available. Please try again.",
        logoTitle: "Anonymous Roasting Game",
        hintExamples: [
            "Type a compliment hint",
            "Type best quality hint",
            "Type my vibe in one word hint",
            "Type something to boost my ego hint",
            "Give a little hint",
            "Type a clue",
            "Type fav food hint",
            "Type fav drink hint",
            "Type fav dessert hint",
            "Type weirdest food hint",
            "Type fav movie/series hint",
            "Type fav song hint",
            "Type fav singer/band hint",
            "Type last movie you watched hint",
            "Type secret crush hint",
            "Type celeb crush hint",
            "Type best friend hint",
            "Type fav hobby hint",
            "Type fav sport hint",
            "Type fav game hint",
            "Type fav social media id hint",
            "Type fav book hint",
            "Type biggest lie you told hint",
            "Type weirdest habit hint",
            "Type funniest fear hint",
            "Type your most embarrassing moment hint",
            "Type weirdest dream hint",
            "Type fav color hint",
            "Type fav car hint",
            "Type fav bike hint",
            "Type fav phone hint",
            "Type fav place hint",
            "Type dream job hint",
            "Type hidden talent hint",
            "Type current mood hint",
            "Type first thing you notice in people hint",
            "Type last DM you sent hint",
            "Type last thing you googled hint",
            "Type fav emoji hint",
            "Type fav character hint",
            "Type fav influencer hint",
            "Type fav outfit hint",
            "Type fav cartoon hint",
            "Type who you wanna date hint",
            "Type who you admire hint",
            "Type who makes you smile hint",
            "Type secret feelings hint",
            "Type funniest thing that happened hint",
            "Type your instagram id",
            "Type your tiktok id",
            "Type your snapchat id"
        ],
        relations: {
            friend: "friend",
            family: "family",
            girlfriend: "girlfriend",
            boyfriend: "boyfriend",
            enemy: "enemy",
            stranger: "stranger"
        },
        common: {
            next: "Next",
            send: "Send",
            clear: "Clear",
            done: "Done",
            skip: "Skip",
            save: "Save",
            edit: "Edit",
            previous: "Previous",
            claim: "Claim",
            que: "Que:",
            nointertoast: "Please turn on internet connection!",
            apiFail: "Request failed. please try again after some time!",
            badWordWarning: "Abusive language is not allowed.",
        },
        noData: {
            title: "Oops! You’re Blocked",
            description: "The content you’re looking for isn’t available.",
            oops: "Oops...",
            nointer: "No internet connection!",
            nointerDes: "Please turn on internet connection!"
        },
        notAllowed: {
            title: "Oops! Limit Reached",
            description: "You’ve hit today’s limit for this category.",
        },
        noData2: {
            title: "No data found.",
            description: "Request failed! Please try again after some time.",
            nointerDes: "Please turn on internet connection!"
        },
        rotate: {
            title: "Please Rotate Your Phone",
            description: "This app works best in portrait mode",
        },
        apiFail: {
            title: "No data found!",
            description: "Request failed! Please try again after some time.."
        },
        pauseLink: {
            title: "Link Paused!",
            description: "This link has been temporarily paused. Please try again later."
        },
        whoTalkin: {
            speakWords1: "Say this word in your",
            speakWords2: "voice anonymously",
            loading: "Loading...",
            defaultQuestion: "Send your voice anonymously!",
            defaultWord: "Nickname",
            recordError: "Recording is too short. Please record for at least 1 second before uploading.",
            unableError: "Unable to access microphone. Please check permissions and try again.",
            denied: "Microphone permission denied.",
            deniedIos: "Microphone access was denied. Please refresh the page.",
            playingError: "Error playing audio. Please try recording again.",
            startError: "Please tap the play button to start audio playback.",
            cancel: "Cancel",
            apiFail: "Request failed. please try again after some time!",
            micPermissionTitle: "Microphone permission denied",
            micPermissionDesc: "Please enable microphone permission from your browser setting.",
            steps: "Follow this step",
            step1: { text: "Click on", bold: "(⋮)", text2: "top-right side" },
            step2: { text: "Open", bold: "Settings > Site Settings", text2: "" },
            step3: { text: "Allow", bold: "Microphone", text2: "" },
            step4: { text: "Page", bold: "refresh", text2: "" },
            ios1: { text: "Tap", bold: "or", text2: "in bottom-left" },
            ios2: { text: "Tap", bold: "(...)", text2: "" },
            ios3: { text: "Allow", bold: "Microphone", text2: "" },
            ios4: { text: "Page", bold: "refresh", text2: "" },
            close: "Done"
        },
        picRoast: {
            entercomment: "Share a funny comment on this photo anonymously",
            entercomment2: "Share a funny comment on this video anonymously",
            loading: "Loading...",
            typeComment: "Type your Comment",
            defaultQuestion: "Drop your best comment for this pic.",
        },
        annoyCard: {
            title: "Pick a funny face for the friend who sent this",
            subTitle: "Share your thoughts about your friend anonymously",
            typeNickname: "Type nickname...",
            scratch: "Scratch to unlock questions",
            write: "Write The Answer To Who Sent This",
            writeAns: "Type answer",
            here: "Scratch here",
            them: "Type them",
            their: "What is their",
            addFace: "Add Face",
            nicknameLbl: "Nick name",
            editTitle: "Edit Your Card"
        },
        emotion: {
            text: "Say this word with",
            text2: "emotion anonymously",
            unableError: "Unable to access microphone. Please check permissions and try again.",
            cardTitle: "What do you think about them?",
            cardPlaceholder: "Write what you feel",
            defaultQuestion: "Guess my mood",
            defaultWord: "OhYeahhhh",
            recordError: "Please hold on button",
            angry: "Angry",
            happy: "Happy",
            love: "Love",
            sad: "Sad",
        },
        hotness: {
            cardTitle: "What do you think about me?",
            cardPlaceholder: "Write something",
            defaultQuestion: "How do I look right now? ",
            spin: "Spin",
            stop: "Stop",
        },
        roast: {
            roastTitle: "Roast me",
            textTitle: "Write a roast anonymously",
            voiceTitle: "Speak a roast anonymously",
            placeholder: "Write a roast…",
            defaultQuestion: "Roast me anonymously",
        },
        confession: {
            textTitle1: "Write a confession anonymously",
            textTitle: "Write a question anonymously",
            title1: "Ask a confession anonymously ",
            title: "Ask a question anonymously ",
            defaultQuestion: "Send your voice anonymously!",
            recordError: "Recording is too short. Please record for at least 1 second before uploading.",
            unableError: "Unable to access microphone. Please check permissions and try again.",
            denied: "Microphone access was denied. Please opening this link in your phone's browser (Safari/Chrome) instead.",
            playingError: "Error playing audio. Please try recording again.",
            startError: "Please tap the play button to start audio playback.",
            typeComment: "Type your",
        },
        friend: {
            title: "Pick a relationship & describe it anonymously",
            placeholder: "Describe your relationship",
            voiceTitle1: "Say it loud & prove it anonymously",
            cardTitle: "Describe your relationship anonymously",
            low: "Low",
            high: "High",
            medium: "Medium",
            hold: "HOLD & SHOUT"
        },
        bluff: {
            title: "Spin & get a bluff topic for me anonymously",
            cardTitle: "Bluff about my",
            cardTitle2: "anonymously",
            cardPlaceholder: "Write a bluff about",
            congo: "Congratulation",
            money: "Money",
            love: "Love",
            lifestyle: "Lifestyle",
            celebrity: "Celebrity",
            funny: "Funny",
            savage: "Savage",
            richLife: "Rich life"
        },
        challenge: {
            title: "Write a challenge anonymously",
            challenge: "Challenge",
            placeholder: "Write a challenge…",
        },
        hellheaven: {
            title: "Answer this to decide their Heaven or Hell — anonymously",
            hell: "Hell",
            heaven: "Heaven",
            no: "No",
            yes: "Yes",
            cardTitle: "Write something about them…"
        },
        reputation: {
            low: "Low",
            average: "Average",
            good: "Good",
            high: "High",
            veryhigh: "Very High",
        },
        completePopup: {
            sent: "Sent!",
            neverMiss: "Don’t miss any replies from",
            peopleTap: "people already sent a message",
            getOwnMessage: "Get your own link 🔗",
            sendAnother: "Send another message",
            newAppFrom: "Try the Prankster app",
            nointertoast: "Please turn on internet connection!",
        }
    },
    hi: {
        enterHints: "अपने बारे में कुछ संकेत लिखें",
        typeHints: "टाइप करें",
        uploadtitle: "अपना सेल्फी संकेत जोड़ें",
        uploaddes1: "अपनी फेस पिक अपलोड करें",
        uploaddes2: "इमेज साइज 5 MB तक",
        popupTitle: "फेस पिक अपलोड करें",
        cameraPermission: "कैमरा एक्सेस अस्वीकृत।",
        cameraMSG: "कृपया अपना चेहरा कैप्चर करें",
        galleryMSG: "कृपया अपना चेहरा जोड़ें",
        sizeError: "इमेज साइज 5MB से अधिक है। कृपया छोटी इमेज चुनें।",
        detectionError: "इमेज में कोई चेहरा नहीं मिला। कृपया स्पष्ट चेहरे वाली इमेज अपलोड करें।",
        cancel: "रद्द करें",
        camera: "कैमरा",
        gallery: "गैलरी",
        avatar: "अवतार",
        hinttext: "टेक्स्ट संकेत",
        hintimage: "सेल्फी संकेत",
        addselfie: "सेल्फी जोड़ें",
        addImage: "इमेज जोड़ें",
        selectRelation: "रिश्ता चुनें",
        cameraPermissionTitle: "कैमरा अनुमति आवश्यक है",
        cameraPermissionDesc: "कृपया ब्राउज़र सेटिंग से माइक्रोफोन अनुमति सक्षम करें।",
        cameraBlockedAndroid: "कैमरा अनुमति ब्लॉक है। सक्षम करने के लिए:\n1. ब्राउज़र में तीन बिंदु (⋮) टैप करें\n2. साइट सेटिंग पर जाएं\n3. कैमरा टैप करें\n4. 'अनुमति दें' चुनें",
        cameraBlockedIOS: "कैमरा अनुमति ब्लॉक है। कृपया ब्राउज़र सेटिंग में सक्षम करें।",
        cameraDenied: "कैमरा एक्सेस अस्वीकृत किया गया",
        cameraNotSupported: "इस डिवाइस पर कैमरा समर्थित नहीं है।",
        galleryNotSupported: "इस डिवाइस पर फ़ाइल एक्सेस समर्थित नहीं है।",
        steps: "यह चरण फॉलो करें",
        cameraStep1: { text: "तीन बिंदु टैप करें", bold: "(⋮)", text2: "ब्राउज़र में" },
        cameraStep2: { text: "जाएं", bold: "साइट सेटिंग", text2: "" },
        cameraStep3: { text: "अनुमति दें", bold: "कैमरा", text2: "" },
        cameraStep4: { text: "पेज", bold: "रिफ्रेश", text2: "" },
        openInSafari: "Safari में खोलें",
        safariStep1: "नीचे शेयर बटन (तीर वाला बॉक्स) टैप करें",
        safariStep2: "स्क्रॉल करें और \"Safari में खोलें\" टैप करें",
        safariStep3: "माइक्रोफोन एक्सेस की अनुमति दें",
        openInChrome: "Chrome में खोलें",
        chromeStep1: "तीन बिंदु (⋮) मेनू टैप करें",
        chromeStep2: "\"Chrome में खोलें\" या \"ब्राउज़र में खोलें\" चुनें",
        chromeStep3: "माइक्रोफोन एक्सेस की अनुमति दें",
        orCopyLink: "लिंक कॉपी करें और दूसरे ब्राउज़र में पेस्ट करें",
        follow: "यह चरण फॉलो करें",
        gotIt: "लिंक कॉपी करें",
        linkCopied: "लिंक कॉपी हो गया!",
        linkCopiedDesc: "अब आप इसे ऐप ब्राउज़र में पेस्ट कर सकते हैं",
        microtitle: "यह ब्राउज़र माइक्रोफोन समर्थित नहीं करता",
        microErrorInstagram: "Instagram का ब्राउज़र माइक्रोफोन एक्सेस समर्थित नहीं करता। कृपया Safari या Chrome में खोलें।",
        microErrorSnapchat: "Snapchat का ब्राउज़र माइक्रोफोन एक्सेस समर्थित नहीं करता। कृपया Safari या Chrome में खोलें।",
        microErrorFacebook: "Facebook का ब्राउज़र माइक्रोफोन एक्सेस समर्थित नहीं करता। कृपया Safari या Chrome में खोलें।",
        microErrorTelegram: "Telegram का ब्राउज़र माइक्रोफोन एक्सेस समर्थित नहीं करता। कृपया Safari या Chrome में खोलें।",
        microErrorDefault: "इस ऐप का ब्राउज़र माइक्रोफोन एक्सेस समर्थित नहीं करता।",
        contentApiFail: "सामग्री उपलब्ध नहीं है। कृपया पुनः प्रयास करें।",
        logoTitle: "अनोनिमस रोस्टिंग गेम",
        hintExamples: [
            "तारीफ का संकेत टाइप करें",
            "सबसे अच्छी क्वालिटी का संकेत टाइप करें",
            "एक शब्द में मेरा वाइब टाइप करें",
            "मेरा ego बढ़ाने वाला संकेत टाइप करें",
            "थोड़ा संकेत दें",
            "एक क्लू टाइप करें",
            "पसंदीदा खाने का संकेत टाइप करें",
            "पसंदीदा ड्रिंक का संकेत टाइप करें",
            "पसंदीदा मिठाई का संकेत टाइप करें",
            "सबसे अजीब खाने का संकेत टाइप करें",
            "पसंदीदा मूवी/सीरीज का संकेत टाइप करें",
            "पसंदीदा गाने का संकेत टाइप करें",
            "पसंदीदा गायक/बैंड का संकेत टाइप करें",
            "आखिरी देखी मूवी का संकेत टाइप करें",
            "सीक्रेट क्रश का संकेत टाइप करें",
            "सेलेब क्रश का संकेत टाइप करें",
            "सबसे अच्छे दोस्त का संकेत टाइप करें",
            "पसंदीदा हॉबी का संकेत टाइप करें",
            "पसंदीदा खेल का संकेत टाइप करें",
            "पसंदीदा गेम का संकेत टाइप करें",
            "पसंदीदा सोशल मीडिया ID का संकेत टाइप करें",
            "पसंदीदा किताब का संकेत टाइप करें",
            "सबसे बड़ा झूठ का संकेत टाइप करें",
            "सबसे अजीब आदत का संकेत टाइप करें",
            "सबसे मज़ेदार डर का संकेत टाइप करें",
            "सबसे शर्मनाक पल का संकेत टाइप करें",
            "सबसे अजीब सपने का संकेत टाइप करें",
            "पसंदीदा रंग का संकेत टाइप करें",
            "पसंदीदा कार का संकेत टाइप करें",
            "पसंदीदा बाइक का संकेत टाइप करें",
            "पसंदीदा फोन का संकेत टाइप करें",
            "पसंदीदा जगह का संकेत टाइप करें",
            "सपनों की नौकरी का संकेत टाइप करें",
            "छुपी प्रतिभा का संकेत टाइप करें",
            "अभी का मूड संकेत टाइप करें",
            "लोगों में पहली नज़र में क्या देखते हैं संकेत टाइप करें",
            "आखिरी DM का संकेत टाइप करें",
            "आखिरी Google सर्च का संकेत टाइप करें",
            "पसंदीदा emoji का संकेत टाइप करें",
            "पसंदीदा किरदार का संकेत टाइप करें",
            "पसंदीदा influencer का संकेत टाइप करें",
            "पसंदीदा outfit का संकेत टाइप करें",
            "पसंदीदा cartoon का संकेत टाइप करें",
            "किससे date करना चाहते हैं संकेत टाइप करें",
            "किसे admire करते हैं संकेत टाइप करें",
            "कौन मुस्कुराता है संकेत टाइप करें",
            "गुप्त भावनाओं का संकेत टाइप करें",
            "सबसे मज़ेदार बात का संकेत टाइप करें",
            "अपना instagram ID टाइप करें",
            "अपना tiktok ID टाइप करें",
            "अपना snapchat ID टाइप करें"
        ],
        relations: {
            friend: "दोस्त",
            family: "परिवार",
            girlfriend: "गर्लफ्रेंड",
            boyfriend: "बॉयफ्रेंड",
            enemy: "दुश्मन",
            stranger: "अजनबी"
        },
        common: {
            next: "अगला",
            send: "भेजें",
            clear: "साफ करें",
            done: "हो गया",
            skip: "छोड़ें",
            save: "सहेजें",
            edit: "संपादित करें",
            previous: "पिछला",
            claim: "क्लेम करें",
            que: "प्रश्न:",
            nointertoast: "कृपया इंटरनेट कनेक्शन चालू करें!",
            apiFail: "अनुरोध विफल। कृपया कुछ समय बाद पुनः प्रयास करें!",
            badWordWarning: "अपमानजनक भाषा की अनुमति नहीं",
        },
        noData: {
            title: "ओह! आप ब्लॉक हैं",
            description: "आप जो सामग्री ढूंढ रहे हैं वह उपलब्ध नहीं है।",
            oops: "ओह...",
            nointer: "इंटरनेट कनेक्शन नहीं है!",
            nointerDes: "कृपया इंटरनेट कनेक्शन चालू करें!"
        },
        notAllowed: {
            title: "ओह! सीमा समाप्त",
            description: "आज इस कैटेगरी की सीमा समाप्त हो गई है।",
        },
        noData2: {
            title: "कोई डेटा नहीं मिला।",
            description: "अनुरोध विफल! कृपया कुछ समय बाद पुनः प्रयास करें।",
            nointerDes: "कृपया इंटरनेट कनेक्शन चालू करें!"
        },
        rotate: {
            title: "कृपया अपना फोन घुमाएं",
            description: "यह ऐप पोर्ट्रेट मोड में सबसे अच्छा काम करता है",
        },
        apiFail: {
            title: "कोई डेटा नहीं मिला!",
            description: "अनुरोध विफल! कृपया कुछ समय बाद पुनः प्रयास करें।"
        },
        pauseLink: {
            title: "लिंक रोका गया!",
            description: "यह लिंक अस्थायी रूप से रोका गया है। कृपया बाद में प्रयास करें।"
        },
        whoTalkin: {
            speakWords1: "यह शब्द अपनी",
            speakWords2: "आवाज़ में गुमनाम रूप से बोलें",
            loading: "लोड हो रहा है...",
            defaultQuestion: "अपनी आवाज़ गुमनाम रूप से भेजें!",
            defaultWord: "उपनाम",
            recordError: "रिकॉर्डिंग बहुत छोटी है। अपलोड करने से पहले कम से कम 1 सेकंड रिकॉर्ड करें।",
            unableError: "माइक्रोफोन एक्सेस नहीं हो पा रहा। कृपया अनुमतियाँ जाँचें और पुनः प्रयास करें।",
            denied: "माइक्रोफोन अनुमति अस्वीकृत।",
            deniedIos: "माइक्रोफोन एक्सेस अस्वीकृत। कृपया पेज रिफ्रेश करें।",
            playingError: "ऑडियो चलाने में त्रुटि। कृपया पुनः रिकॉर्ड करें।",
            startError: "ऑडियो शुरू करने के लिए प्ले बटन टैप करें।",
            cancel: "रद्द करें",
            apiFail: "अनुरोध विफल। कृपया कुछ समय बाद पुनः प्रयास करें!",
            micPermissionTitle: "माइक्रोफोन अनुमति अस्वीकृत",
            micPermissionDesc: "कृपया ब्राउज़र सेटिंग से माइक्रोफोन अनुमति सक्षम करें।",
            steps: "यह चरण फॉलो करें",
            step1: { text: "क्लिक करें", bold: "(⋮)", text2: "ऊपर दाईं तरफ" },
            step2: { text: "खोलें", bold: "सेटिंग > साइट सेटिंग", text2: "" },
            step3: { text: "अनुमति दें", bold: "माइक्रोफोन", text2: "" },
            step4: { text: "पेज", bold: "रिफ्रेश", text2: "" },
            ios1: { text: "टैप करें", bold: "या", text2: "नीचे बाईं तरफ" },
            ios2: { text: "टैप करें", bold: "(...)", text2: "" },
            ios3: { text: "अनुमति दें", bold: "माइक्रोफोन", text2: "" },
            ios4: { text: "पेज", bold: "रिफ्रेश", text2: "" },
            close: "हो गया"
        },
        picRoast: {
            entercomment: "इस फोटो पर मज़ेदार कमेंट गुमनाम रूप से शेयर करें",
            entercomment2: "इस वीडियो पर मज़ेदार कमेंट गुमनाम रूप से शेयर करें",
            loading: "लोड हो रहा है...",
            typeComment: "अपना कमेंट टाइप करें",
            defaultQuestion: "इस पिक के लिए अपना बेस्ट कमेंट डालें।",
        },
        annoyCard: {
            title: "मज़ेदार चेहरा चुनें उस दोस्त के लिए जिसने यह भेजा है",
            subTitle: "अपने दोस्त के बारे में अपने विचार गुमनाम रूप से साझा करें",
            typeNickname: "उपनाम टाइप करें...",
            scratch: "सवालों को अनलॉक करने के लिए स्क्रैच करें",
            write: "जिसने यह भेजा उसे जवाब लिखें",
            writeAns: "जवाब टाइप करें",
            here: "यहाँ खरोंचें",
            them: "उन्हें टाइप करें",
            their: "उनका क्या है",
            addFace: "चेहरा जोड़ें",
            nicknameLbl: "उपनाम",
            editTitle: "अपना कार्ड संपादित करें"
        },
        emotion: {
            text: "इस शब्द को भावना के साथ",
            text2: "गुमनाम रूप से कहें",
            unableError: "माइक्रोफोन एक्सेस नहीं हो पा रहा। कृपया अनुमतियाँ जाँचें और पुनः प्रयास करें।",
            cardTitle: "आप उनके बारे में क्या सोचते हैं?",
            cardPlaceholder: "आप जो महसूस करते हैं, लिखें",
            defaultQuestion: "मेरा मूड अनुमान करें",
            defaultWord: "ओहYeahhhh",
            recordError: "कृपया बटन दबाए रखें",
            angry: "गुस्सा",
            happy: "खुश",
            love: "प्यार",
            sad: "दुखी",
        },
        hotness: {
            cardTitle: "आप मेरे बारे में क्या सोचते हैं?",
            cardPlaceholder: "कुछ लिखें",
            defaultQuestion: "मैं अभी कैसा/कैसी दिख रहा/रही हूँ?",
            spin: "घुमाएं",
            stop: "रोकें",
        },
        roast: {
            roastTitle: "रोस्ट करें",
            textTitle: "गुमनाम रूप से रोस्ट लिखें",
            voiceTitle: "गुमनाम रूप से रोस्ट बोलें",
            placeholder: "रोस्ट लिखें…",
            defaultQuestion: "मुझे गुमनाम रूप से रोस्ट करें",
        },
        confession: {
            textTitle1: "गुमनाम रूप से एक कन्फेशन लिखें",
            textTitle: "गुमनाम रूप से एक सवाल लिखें",
            title1: "गुमनाम रूप से कन्फेशन पूछें",
            title: "गुमनाम रूप से सवाल पूछें",
            defaultQuestion: "अपनी आवाज़ गुमनाम रूप से भेजें!",
            recordError: "रिकॉर्डिंग बहुत छोटी है। कम से कम 1 सेकंड रिकॉर्ड करें।",
            unableError: "माइक्रोफोन एक्सेस नहीं हो पा रहा। कृपया अनुमतियाँ जाँचें।",
            denied: "माइक्रोफोन एक्सेस अस्वीकृत। कृपया इस लिंक को फोन के ब्राउज़र (Safari/Chrome) में खोलें।",
            playingError: "ऑडियो चलाने में त्रुटि। कृपया पुनः रिकॉर्ड करें।",
            startError: "ऑडियो शुरू करने के लिए प्ले बटन टैप करें।",
            typeComment: "अपना टाइप करें",
        },
        friend: {
            title: "एक रिश्ते को चुनें और उसे गुमनाम रूप से वर्णित करें",
            placeholder: "अपने रिश्ते का वर्णन करें",
            voiceTitle1: "खुलकर कहें और इसे गुमनाम रूप से साबित करें",
            cardTitle: "गुमनाम रूप रिश्ते का वर्णन करें",
            low: "कम",
            high: "ज़्यादा",
            medium: "मध्यम",
            hold: "दबाए रखें & चिल्लाएं"
        },
        bluff: {
            title: "स्पिन करें और मेरे लिए गुमनाम ब्लफ टॉपिक पाएं",
            cardTitle: "मेरे बारे में ब्लफ करें",
            cardTitle2: "गुमनाम रूप से",
            cardPlaceholder: "इसके बारे में ब्लफ लिखें",
            congo: "बधाई हो",
            money: "पैसा",
            love: "प्यार",
            lifestyle: "लाइफस्टाइल",
            celebrity: "सेलेब्रिटी",
            funny: "मज़ेदार",
            savage: "सैवेज",
            richLife: "अमीर जीवन"
        },
        challenge: {
            title: "गुमनाम रूप से एक चुनौती लिखें",
            challenge: "चुनौती",
            placeholder: "एक चुनौती लिखें…"
        },
        hellheaven: {
            title: "इसे गुमनाम रूप से उत्तर दें और तय करें कि वे स्वर्ग में जाएंगे या नरक में",
            hell: "नर्क",
            heaven: "स्वर्ग",
            no: "नहीं",
            yes: "हाँ",
            cardTitle: "उनके बारे में कुछ लिखें…"
        },
        reputation: {
            low: "कम",
            average: "औसत",
            good: "अच्छा",
            high: "उच्च",
            veryhigh: "बहुत उच्च",
        },
        completePopup: {
            sent: "भेज दिया!",
            neverMiss: "से कोई जवाब न चूकें",
            peopleTap: "लोगों ने पहले ही संदेश भेजा है",
            getOwnMessage: "अपना लिंक पाएं 🔗",
            sendAnother: "एक और संदेश भेजें",
            newAppFrom: "Prankster ऐप आज़माएं",
            nointertoast: "कृपया इंटरनेट कनेक्शन चालू करें!",
        }
    },
    enhi: {
        enterHints: "Apne baare mein kuch hints likho",
        typeHints: "Type karo",
        uploadtitle: "Apna selfie hint add karo",
        uploaddes1: "Apni face pic upload karo",
        uploaddes2: "Image size 5 MB tak",
        popupTitle: "Face pic upload karo",
        cameraPermission: "Camera access denied.",
        cameraMSG: "Please apna face capture karo",
        galleryMSG: "Please apna face add karo",
        sizeError: "Image size 5MB se zyada hai. Please choti image choose karo.",
        detectionError: "Image mein koi face detect nahi hua. Please clear face wali image upload karo.",
        cancel: "Cancel",
        camera: "Camera",
        gallery: "Gallery",
        avatar: "Avatar",
        hinttext: "Text Hint",
        hintimage: "Selfie Hint",
        addselfie: "Selfie add karo",
        addImage: "Image add karo",
        selectRelation: "Relation select karo",
        cameraPermissionTitle: "Camera Permission chahiye",
        cameraPermissionDesc: "Please browser settings se microphone permission enable karo.",
        cameraBlockedAndroid: "Camera permission block hai. Enable karne ke liye:\n1. Browser mein teen dots (⋮) tap karo\n2. Site settings mein jao\n3. Camera tap karo\n4. 'Allow' select karo",
        cameraBlockedIOS: "Camera permission block hai. Please browser settings mein enable karo.",
        cameraDenied: "Camera access deny ho gaya",
        cameraNotSupported: "Is device par camera support nahi karta.",
        galleryNotSupported: "Is device par file access support nahi karta.",
        steps: "Ye step follow karo",
        cameraStep1: { text: "Teen dots tap karo", bold: "(⋮)", text2: "browser mein" },
        cameraStep2: { text: "Jao", bold: "Site settings", text2: "" },
        cameraStep3: { text: "Allow karo", bold: "Camera", text2: "" },
        cameraStep4: { text: "Page", bold: "refresh", text2: "" },
        openInSafari: "Safari mein kholo",
        safariStep1: "Neeche Share button (arrow wala box) tap karo",
        safariStep2: "Scroll karo aur \"Safari mein kholo\" tap karo",
        safariStep3: "Microphone access allow karo jab pucha jaye",
        openInChrome: "Chrome mein kholo",
        chromeStep1: "Teen dots (⋮) menu tap karo",
        chromeStep2: "\"Chrome mein kholo\" ya \"Browser mein kholo\" select karo",
        chromeStep3: "Microphone access allow karo jab pucha jaye",
        orCopyLink: "Link copy karo aur doosre browser mein paste karo",
        follow: "Ye step follow karo",
        gotIt: "Link copy karo",
        linkCopied: "Link Copy ho gaya!",
        linkCopiedDesc: "Ab tum ise app browser mein paste kar sakte ho",
        microtitle: "Ye browser microphone support nahi karta",
        microErrorInstagram: "Instagram ka browser microphone access support nahi karta. Please Safari ya Chrome mein kholo.",
        microErrorSnapchat: "Snapchat ka browser microphone access support nahi karta. Please Safari ya Chrome mein kholo.",
        microErrorFacebook: "Facebook ka browser microphone access support nahi karta. Please Safari ya Chrome mein kholo.",
        microErrorTelegram: "Telegram ka browser microphone access support nahi karta. Please Safari ya Chrome mein kholo.",
        microErrorDefault: "Is app ka browser microphone access support nahi karta.",
        contentApiFail: "Content available nahi hai. Please dobara try karo.",
        logoTitle: "Anonymous Roasting Game",
        hintExamples: [
            "Ek compliment hint type karo",
            "Best quality hint type karo",
            "Mera vibe ek word mein type karo",
            "Mera ego boost karne wala hint type karo",
            "Thoda sa hint do",
            "Ek clue type karo",
            "Fav food hint type karo",
            "Fav drink hint type karo",
            "Fav dessert hint type karo",
            "Weirdest food hint type karo",
            "Fav movie/series hint type karo",
            "Fav song hint type karo",
            "Fav singer/band hint type karo",
            "Last dekhi movie hint type karo",
            "Secret crush hint type karo",
            "Celeb crush hint type karo",
            "Best friend hint type karo",
            "Fav hobby hint type karo",
            "Fav sport hint type karo",
            "Fav game hint type karo",
            "Fav social media ID hint type karo",
            "Fav book hint type karo",
            "Sabse bada jhooth hint type karo",
            "Weirdest habit hint type karo",
            "Funniest fear hint type karo",
            "Sabse embarrassing moment hint type karo",
            "Weirdest dream hint type karo",
            "Fav color hint type karo",
            "Fav car hint type karo",
            "Fav bike hint type karo",
            "Fav phone hint type karo",
            "Fav place hint type karo",
            "Dream job hint type karo",
            "Hidden talent hint type karo",
            "Current mood hint type karo",
            "Logon mein pehli cheez jo notice karte ho hint type karo",
            "Last DM hint type karo",
            "Last Google search hint type karo",
            "Fav emoji hint type karo",
            "Fav character hint type karo",
            "Fav influencer hint type karo",
            "Fav outfit hint type karo",
            "Fav cartoon hint type karo",
            "Kisse date karna chahte ho hint type karo",
            "Kisse admire karte ho hint type karo",
            "Kaun tumhe smile karta hai hint type karo",
            "Secret feelings hint type karo",
            "Funniest cheez hint type karo",
            "Apna instagram ID type karo",
            "Apna tiktok ID type karo",
            "Apna snapchat ID type karo"
        ],
        relations: {
            friend: "Dost",
            family: "Family",
            girlfriend: "Girlfriend",
            boyfriend: "Boyfriend",
            enemy: "Dushman",
            stranger: "Stranger"
        },
        common: {
            next: "Next",
            send: "Bhejo",
            clear: "Clear",
            done: "Done",
            skip: "Skip",
            save: "Save karo",
            edit: "Edit karo",
            previous: "Pehle wala",
            claim: "Claim karo",
            que: "Sawal:",
            nointertoast: "Please internet connection on karo!",
            apiFail: "Request fail. Please thodi der baad dobara try karo!",
            badWordWarning: "Abusive language allowed nahi hai",
        },
        noData: {
            title: "Oops! Tum Block ho",
            description: "Jo content tum dhundh rahe ho wo available nahi hai.",
            oops: "Oops...",
            nointer: "Internet connection nahi hai!",
            nointerDes: "Please internet connection on karo!"
        },
        notAllowed: {
            title: "Oops! Limit khatam",
            description: "Aaj is category ki limit khatam ho gayi hai.",
        },
        noData2: {
            title: "Koi data nahi mila.",
            description: "Request fail! Please thodi der baad dobara try karo.",
            nointerDes: "Please internet connection on karo!"
        },
        rotate: {
            title: "Please apna phone rotate karo",
            description: "Yeh app portrait mode mein best kaam karta hai",
        },
        apiFail: {
            title: "Koi data nahi mila!",
            description: "Request fail! Please thodi der baad dobara try karo."
        },
        pauseLink: {
            title: "Link Paused!",
            description: "Ye link temporarily pause hai. Please baad mein try karo."
        },
        whoTalkin: {
            speakWords1: "Ye word apni",
            speakWords2: "awaaz mein anonymously bolo",
            loading: "Loading...",
            defaultQuestion: "Apni awaaz anonymously bhejo!",
            defaultWord: "Nickname",
            recordError: "Recording bahut choti hai. Upload karne se pehle kam se kam 1 second record karo.",
            unableError: "Microphone access nahi ho pa raha. Please permissions check karo aur dobara try karo.",
            denied: "Microphone permission denied.",
            deniedIos: "Microphone access deny hua. Please page refresh karo.",
            playingError: "Audio chalane mein error. Please dobara record karo.",
            startError: "Audio shuru karne ke liye play button tap karo.",
            cancel: "Cancel",
            apiFail: "Request fail. Please thodi der baad dobara try karo!",
            micPermissionTitle: "Microphone permission denied",
            micPermissionDesc: "Please browser setting se microphone permission enable karo.",
            steps: "Ye step follow karo",
            step1: { text: "Click karo", bold: "(⋮)", text2: "upar dayi taraf" },
            step2: { text: "Kholo", bold: "Settings > Site Settings", text2: "" },
            step3: { text: "Allow karo", bold: "Microphone", text2: "" },
            step4: { text: "Page", bold: "refresh", text2: "" },
            ios1: { text: "Tap karo", bold: "ya", text2: "neeche bayi taraf" },
            ios2: { text: "Tap karo", bold: "(...)", text2: "" },
            ios3: { text: "Allow karo", bold: "Microphone", text2: "" },
            ios4: { text: "Page", bold: "refresh", text2: "" },
            close: "Done"
        },
        picRoast: {
            entercomment: "Is photo par ek mazedaar comment anonymously share karein",
            entercomment2: "Is video par ek mazedaar comment anonymously share karein",
            loading: "Loading...",
            typeComment: "Apna Comment type karo",
            defaultQuestion: "Is pic ke liye apna best comment dalo.",
        },
        annoyCard: {
            title: "Is bhejne wale dost ke liye ek funny face choose karo",
            subTitle: "Apne dost ke baare mein apne thoughts anonymously share karo",
            typeNickname: "Nickname type karo...",
            scratch: "Questions unlock karne ke liye scratch karo",
            write: "Jisne ye bheja usse jawab likho",
            writeAns: "Jawab type karo",
            send: "Bhejo",
            here: "Yahan scratch karo",
            them: "Unhe type karo",
            their: "Unka kya hai",
            addFace: "Face add karo",
            nicknameLbl: "Nick name",
            editTitle: "Apna card edit karo"
        },
        emotion: {
            text: "Is word ko emotion ke saath",
            text2: "anonymously bolo",
            unableError: "Microphone access nahi ho pa raha. Please permissions check karo aur dobara try karo.",
            cardTitle: "Tum unke baare mein kya sochte ho?",
            cardPlaceholder: "Jo feel karte ho woh likho",
            defaultQuestion: "Mera mood guess karo",
            defaultWord: "OhYeahhhh",
            recordError: "Please button dabaye rakho",
            angry: "Gussa",
            happy: "Khush",
            love: "Pyaar",
            sad: "Udaas",
        },
        hotness: {
            cardTitle: "Tum mere baare mein kya sochte ho?",
            cardPlaceholder: "Kuch likho",
            defaultQuestion: "Main abhi kaisa/kaisi dikh raha/rahi hoon?",
            spin: "Spin karo",
            stop: "Roko",
        },
        roast: {
            roastTitle: "Mujhe roast karo",
            textTitle: "Anonymously roast likho",
            voiceTitle: "Anonymously roast bolo",
            placeholder: "Roast likho…",
            defaultQuestion: "Mujhe anonymously roast karo",
        },
        confession: {
            textTitle1: "Anonymously ek confession likho",
            textTitle: "Anonymously ek sawaal likho",
            title1: "Anonymously confession pucho",
            title: "Anonymously sawaal pucho",
            defaultQuestion: "Apni awaaz anonymously bhejo!",
            recordError: "Recording bahut choti hai. Kam se kam 1 second record karo.",
            unableError: "Microphone access nahi ho pa raha. Please permissions check karo.",
            denied: "Microphone access deny hua. Please is link ko phone ke browser (Safari/Chrome) mein kholo.",
            playingError: "Audio chalane mein error. Please dobara record karo.",
            startError: "Audio shuru karne ke liye play button tap karo.",
            typeComment: "Apna type karo",
        },
        friend: {
            title: "ek relationship choose karo aur usse anonymously describe karo",
            placeholder: "Apna relationship describe karo",
            voiceTitle1: "Dil khol ke bolo aur anonymously prove karo",
            cardTitle: "Anonymously relationship describe karo",
            low: "Low",
            high: "High",
            medium: "Medium",
            hold: "HOLD & CHILLAO"
        },
        bluff: {
            title: "Spin karo aur mere liye anonymously bluff topic pao",
            cardTitle: "Mere baare mein bluff karo",
            cardTitle2: "anonymously",
            cardPlaceholder: "Iske baare mein bluff likho",
            congo: "Badhaai ho",
            money: "Paisa",
            love: "Pyaar",
            lifestyle: "Lifestyle",
            celebrity: "Celebrity",
            funny: "Funny",
            savage: "Savage",
            richLife: "Ameer Zindagi"
        },
        challenge: {
            title: "Anonymously ek challenge likho",
            challenge: "Challenge",
            placeholder: "Ek challenge likho…"
        },
        hellheaven: {
            title: "Iska jawab anonymously do aur decide karo ke wo swarg ya narak me jayenge",
            hell: "Hell",
            heaven: "Heaven",
            no: "Nahi",
            yes: "Haan",
            cardTitle: "Unke baare mein kuch likho…"
        },
        reputation: {
            low: "Low",
            average: "Average",
            good: "Good",
            high: "High",
            veryhigh: "Very High",
        },
        completePopup: {
            sent: "Bhej diya!",
            neverMiss: "se koi bhi reply miss mat karo",
            peopleTap: "logon ne pehle hi message bhej diya",
            getOwnMessage: "Apna link pao 🔗",
            sendAnother: "Ek aur message bhejo",
            newAppFrom: "Prankster app try karo",
            nointertoast: "Please internet connection on karo!",
        }
    },
    mr: {
        enterHints: "स्वतःबद्दल काही इशारे लिहा",
        typeHints: "टाइप करा",
        uploadtitle: "तुमचा सेल्फी इशारा जोडा",
        uploaddes1: "तुमचा फेस फोटो अपलोड करा",
        uploaddes2: "इमेज साइज 5 MB पर्यंत",
        popupTitle: "फेस फोटो अपलोड करा",
        cameraPermission: "कॅमेरा ऍक्सेस नाकारला.",
        cameraMSG: "कृपया तुमचा चेहरा कॅप्चर करा",
        galleryMSG: "कृपया तुमचा चेहरा जोडा",
        sizeError: "इमेज साइज 5MB पेक्षा जास्त आहे. कृपया लहान इमेज निवडा.",
        detectionError: "इमेजमध्ये कोणताही चेहरा आढळला नाही. कृपया स्पष्ट चेहऱ्याची इमेज अपलोड करा.",
        cancel: "रद्द करा",
        camera: "कॅमेरा",
        gallery: "गॅलरी",
        avatar: "अवतार",
        hinttext: "मजकूर इशारा",
        hintimage: "सेल्फी इशारा",
        addselfie: "सेल्फी जोडा",
        addImage: "इमेज जोडा",
        selectRelation: "नाते निवडा",
        cameraPermissionTitle: "कॅमेरा परवानगी आवश्यक आहे",
        cameraPermissionDesc: "कृपया ब्राउझर सेटिंगमधून मायक्रोफोन परवानगी सक्षम करा.",
        cameraBlockedAndroid: "कॅमेरा परवानगी ब्लॉक आहे. सक्षम करण्यासाठी:\n1. ब्राउझरमध्ये तीन ठिपके (⋮) टॅप करा\n2. साइट सेटिंग्जमध्ये जा\n3. कॅमेरा टॅप करा\n4. 'परवानगी द्या' निवडा",
        cameraBlockedIOS: "कॅमेरा परवानगी ब्लॉक आहे. कृपया ब्राउझर सेटिंग्जमध्ये सक्षम करा.",
        cameraDenied: "कॅमेरा ऍक्सेस नाकारला गेला",
        cameraNotSupported: "या डिव्हाइसवर कॅमेरा समर्थित नाही.",
        galleryNotSupported: "या डिव्हाइसवर फाइल ऍक्सेस समर्थित नाही.",
        steps: "हे पाऊल फॉलो करा",
        cameraStep1: { text: "तीन ठिपके टॅप करा", bold: "(⋮)", text2: "ब्राउझरमध्ये" },
        cameraStep2: { text: "जा", bold: "साइट सेटिंग्ज", text2: "" },
        cameraStep3: { text: "परवानगी द्या", bold: "कॅमेरा", text2: "" },
        cameraStep4: { text: "पेज", bold: "रिफ्रेश", text2: "" },
        openInSafari: "Safari मध्ये उघडा",
        safariStep1: "खाली शेअर बटण (बाण असलेला बॉक्स) टॅप करा",
        safariStep2: "स्क्रोल करा आणि \"Safari मध्ये उघडा\" टॅप करा",
        safariStep3: "मायक्रोफोन ऍक्सेसला परवानगी द्या",
        openInChrome: "Chrome मध्ये उघडा",
        chromeStep1: "तीन ठिपके (⋮) मेनू टॅप करा",
        chromeStep2: "\"Chrome मध्ये उघडा\" किंवा \"ब्राउझरमध्ये उघडा\" निवडा",
        chromeStep3: "मायक्रोफोन ऍक्सेसला परवानगी द्या",
        orCopyLink: "लिंक कॉपी करा आणि दुसऱ्या ब्राउझरमध्ये पेस्ट करा",
        follow: "हे पाऊल फॉलो करा",
        gotIt: "लिंक कॉपी करा",
        linkCopied: "लिंक कॉपी झाली!",
        linkCopiedDesc: "आता तुम्ही हे अॅप ब्राउझरमध्ये पेस्ट करू शकता",
        microtitle: "हा ब्राउझर मायक्रोफोन समर्थित करत नाही",
        microErrorInstagram: "Instagram चा ब्राउझर मायक्रोफोन ऍक्सेस समर्थित करत नाही. कृपया Safari किंवा Chrome मध्ये उघडा.",
        microErrorSnapchat: "Snapchat चा ब्राउझर मायक्रोफोन ऍक्सेस समर्थित करत नाही. कृपया Safari किंवा Chrome मध्ये उघडा.",
        microErrorFacebook: "Facebook चा ब्राउझर मायक्रोफोन ऍक्सेस समर्थित करत नाही. कृपया Safari किंवा Chrome मध्ये उघडा.",
        microErrorTelegram: "Telegram चा ब्राउझर मायक्रोफोन ऍक्सेस समर्थित करत नाही. कृपया Safari किंवा Chrome मध्ये उघडा.",
        microErrorDefault: "या अॅपचा ब्राउझर मायक्रोफोन ऍक्सेस समर्थित करत नाही.",
        contentApiFail: "सामग्री उपलब्ध नाही. कृपया पुन्हा प्रयत्न करा.",
        logoTitle: "अनामिक रोस्टिंग गेम",
        hintExamples: [
            "एक कॉम्प्लिमेंट इशारा टाइप करा",
            "सर्वोत्तम गुणवत्ता इशारा टाइप करा",
            "एका शब्दात माझा वाइब टाइप करा",
            "माझा ego वाढवणारा इशारा टाइप करा",
            "थोडा इशारा द्या",
            "एक क्लू टाइप करा",
            "आवडता खाद्यपदार्थ इशारा टाइप करा",
            "आवडते पेय इशारा टाइप करा",
            "आवडती मिठाई इशारा टाइप करा",
            "सर्वात विचित्र खाद्यपदार्थ इशारा टाइप करा",
            "आवडता चित्रपट/मालिका इशारा टाइप करा",
            "आवडते गाणे इशारा टाइप करा",
            "आवडता गायक/बँड इशारा टाइप करा",
            "शेवटी पाहिलेला चित्रपट इशारा टाइप करा",
            "गुप्त क्रश इशारा टाइप करा",
            "सेलेब क्रश इशारा टाइप करा",
            "सर्वोत्तम मित्र इशारा टाइप करा",
            "आवडता छंद इशारा टाइप करा",
            "आवडता खेळ इशारा टाइप करा",
            "आवडता गेम इशारा टाइप करा",
            "आवडता सोशल मीडिया ID इशारा टाइप करा",
            "आवडते पुस्तक इशारा टाइप करा",
            "सर्वात मोठे खोटे इशारा टाइप करा",
            "सर्वात विचित्र सवय इशारा टाइप करा",
            "सर्वात मजेदार भीती इशारा टाइप करा",
            "सर्वात लाजिरवाणा क्षण इशारा टाइप करा",
            "सर्वात विचित्र स्वप्न इशारा टाइप करा",
            "आवडता रंग इशारा टाइप करा",
            "आवडती कार इशारा टाइप करा",
            "आवडती बाइक इशारा टाइप करा",
            "आवडता फोन इशारा टाइप करा",
            "आवडती जागा इशारा टाइप करा",
            "स्वप्नातील नोकरी इशारा टाइप करा",
            "लपलेली प्रतिभा इशारा टाइप करा",
            "सध्याचा मूड इशारा टाइप करा",
            "लोकांमध्ये पहिल्यांदा काय लक्षात येते इशारा टाइप करा",
            "शेवटचा DM इशारा टाइप करा",
            "शेवटचा Google शोध इशारा टाइप करा",
            "आवडता emoji इशारा टाइप करा",
            "आवडता पात्र इशारा टाइप करा",
            "आवडता influencer इशारा टाइप करा",
            "आवडता outfit इशारा टाइप करा",
            "आवडता cartoon इशारा टाइप करा",
            "कोणाशी date करायचे आहे इशारा टाइप करा",
            "कोणाचे admire करता इशारा टाइप करा",
            "कोण हसवते इशारा टाइप करा",
            "गुप्त भावना इशारा टाइप करा",
            "सर्वात मजेदार गोष्ट इशारा टाइप करा",
            "तुमचा instagram ID टाइप करा",
            "तुमचा tiktok ID टाइप करा",
            "तुमचा snapchat ID टाइप करा"
        ],
        relations: {
            friend: "मित्र",
            family: "कुटुंब",
            girlfriend: "गर्लफ्रेंड",
            boyfriend: "बॉयफ्रेंड",
            enemy: "शत्रू",
            stranger: "अनोळखी"
        },
        common: {
            next: "पुढे",
            send: "पाठवा",
            clear: "साफ करा",
            done: "झाले",
            skip: "वगळा",
            save: "जतन करा",
            edit: "संपादित करा",
            previous: "मागील",
            claim: "क्लेम करा",
            que: "प्रश्न:",
            nointertoast: "कृपया इंटरनेट कनेक्शन चालू करा!",
            apiFail: "विनंती अयशस्वी. कृपया थोड्या वेळाने पुन्हा प्रयत्न करा!",
            badWordWarning: "अपमानास्पद भाषा वापरण्यास परवानगी नाही",
        },
        noData: {
            title: "अरे! तुम्ही ब्लॉक आहात",
            description: "तुम्ही शोधत असलेली सामग्री उपलब्ध नाही.",
            oops: "अरे...",
            nointer: "इंटरनेट कनेक्शन नाही!",
            nointerDes: "कृपया इंटरनेट कनेक्शन चालू करा!"
        },
        notAllowed: {
            title: "अरे! मर्यादा संपली",
            description: "आजची या श्रेणीची मर्यादा संपली आहे.",
        },
        noData2: {
            title: "कोणताही डेटा आढळला नाही.",
            description: "विनंती अयशस्वी! कृपया थोड्या वेळाने पुन्हा प्रयत्न करा.",
            nointerDes: "कृपया इंटरनेट कनेक्शन चालू करा!"
        }, rotate: {
            title: "कृपया तुमचा फोन फिरवा",
            description: "हे अ‍ॅप पोर्ट्रेट मोडमध्ये उत्तम काम करते",
        },
        apiFail: {
            title: "कोणताही डेटा आढळला नाही!",
            description: "विनंती अयशस्वी! कृपया थोड्या वेळाने पुन्हा प्रयत्न करा."
        },
        pauseLink: {
            title: "लिंक थांबवली!",
            description: "ही लिंक तात्पुरती थांबवली आहे. कृपया नंतर प्रयत्न करा."
        },
        whoTalkin: {
            speakWords1: "हा शब्द तुमच्या",
            speakWords2: "आवाजात अनामिकपणे बोला",
            loading: "लोड होत आहे...",
            defaultQuestion: "तुमचा आवाज अनामिकपणे पाठवा!",
            defaultWord: "टोपणनाव",
            recordError: "रेकॉर्डिंग खूप लहान आहे. अपलोड करण्यापूर्वी किमान 1 सेकंद रेकॉर्ड करा.",
            unableError: "मायक्रोफोन ऍक्सेस होत नाही. कृपया परवानग्या तपासा आणि पुन्हा प्रयत्न करा.",
            denied: "मायक्रोफोन परवानगी नाकारली.",
            deniedIos: "मायक्रोफोन ऍक्सेस नाकारला. कृपया पेज रिफ्रेश करा.",
            playingError: "ऑडिओ चालवण्यात त्रुटी. कृपया पुन्हा रेकॉर्ड करा.",
            startError: "ऑडिओ सुरू करण्यासाठी प्ले बटण टॅप करा.",
            cancel: "रद्द करा",
            apiFail: "विनंती अयशस्वी. कृपया थोड्या वेळाने पुन्हा प्रयत्न करा!",
            micPermissionTitle: "मायक्रोफोन परवानगी नाकारली",
            micPermissionDesc: "कृपया ब्राउझर सेटिंगमधून मायक्रोफोन परवानगी सक्षम करा.",
            steps: "हे पाऊल फॉलो करा",
            step1: { text: "क्लिक करा", bold: "(⋮)", text2: "वर उजव्या बाजूला" },
            step2: { text: "उघडा", bold: "सेटिंग्ज > साइट सेटिंग्ज", text2: "" },
            step3: { text: "परवानगी द्या", bold: "मायक्रोफोन", text2: "" },
            step4: { text: "पेज", bold: "रिफ्रेश", text2: "" },
            ios1: { text: "टॅप करा", bold: "किंवा", text2: "खाली डाव्या बाजूला" },
            ios2: { text: "टॅप करा", bold: "(...)", text2: "" },
            ios3: { text: "परवानगी द्या", bold: "मायक्रोफोन", text2: "" },
            ios4: { text: "पेज", bold: "रिफ्रेश", text2: "" },
            close: "झाले"
        },
        picRoast: {
            entercomment: "या फोटोवर एक मजेदार कमेंट गुप्तपणे शेअर करा",
            entercomment2: "या व्हिडिओवर एक मजेदार कमेंट गुप्तपणे शेअर करा",
            loading: "लोड होत आहे...",
            typeComment: "तुमची कमेंट टाइप करा",
            defaultQuestion: "या फोटोसाठी तुमची सर्वोत्तम कमेंट द्या.",
        },
        annoyCard: {
            title: "हे पाठवणाऱ्या मित्रासाठी एक मजेदार चेहरा निवडा",
            subTitle: "तुमच्या मित्राबद्दल तुमचे विचार अनामिकपणे शेअर करा",
            typeNickname: "टोपणनाव टाइप करा...",
            scratch: "प्रश्न अनलॉक करण्यासाठी स्क्रॅच करा",
            write: "ज्याने हे पाठवले त्याला उत्तर लिहा",
            writeAns: "उत्तर टाइप करा",
            send: "पाठवा",
            here: "येथे खरवडा",
            them: "त्यांना टाइप करा",
            their: "त्यांचे काय आहे",
            addFace: "चेहरा जोडा",
            nicknameLbl: "टोपणनाव",
            editTitle: "तुमचा कार्ड संपादित करा"
        },
        emotion: {
            text: "हा शब्द भावना व्यक्त करून",
            text2: "बोला गुप्तपणे",
            unableError: "मायक्रोफोन ऍक्सेस होत नाही. कृपया परवानग्या तपासा आणि पुन्हा प्रयत्न करा.",
            cardTitle: "तुम्हाला त्यांच्याबद्दल काय वाटते?",
            cardPlaceholder: "तुम्हाला जे वाटते ते लिहा",
            defaultQuestion: "माझा मूड अंदाज करा",
            defaultWord: "OhYeahhhh",
            recordError: "कृपया बटण दाबून ठेवा",
            angry: "रागावलेला",
            happy: "आनंदी",
            love: "प्रेम",
            sad: "दुःखी",
        },
        hotness: {
            cardTitle: "तुम्हाला माझ्याबद्दल काय वाटते?",
            cardPlaceholder: "काहीतरी लिहा",
            defaultQuestion: "मी आत्ता कसा/कशी दिसतो/दिसते?",
            spin: "फिरवा",
            stop: "थांबवा",
        },
        roast: {
            roastTitle: "मला रोस्ट करा",
            textTitle: "गुप्तपणे रोस्ट लिहा",
            voiceTitle: "गुप्तपणे रोस्ट बोला",
            placeholder: "रोस्ट लिहा…",
            defaultQuestion: "मला अनामिकपणे रोस्ट करा",
        },
        confession: {
            textTitle1: "अनामिकपणे एक कन्फेशन लिहा",
            textTitle: "अनामिकपणे एक प्रश्न लिहा",
            title1: "अनामिकपणे कन्फेशन विचारा",
            title: "अनामिकपणे प्रश्न विचारा",
            defaultQuestion: "तुमचा आवाज अनामिकपणे पाठवा!",
            recordError: "रेकॉर्डिंग खूप लहान आहे. किमान 1 सेकंद रेकॉर्ड करा.",
            unableError: "मायक्रोफोन ऍक्सेस होत नाही. कृपया परवानग्या तपासा.",
            denied: "मायक्रोफोन ऍक्सेस नाकारला. कृपया ही लिंक फोनच्या ब्राउझरमध्ये (Safari/Chrome) उघडा.",
            playingError: "ऑडिओ चालवण्यात त्रुटी. कृपया पुन्हा रेकॉर्ड करा.",
            startError: "ऑडिओ सुरू करण्यासाठी प्ले बटण टॅप करा.",
            typeComment: "तुमचे टाइप करा",
        },
        friend: {
            title: "एखादं नातं निवडा आणि ते गुप्तपणे वर्णन करा",
            placeholder: "तुमच्या नात्याचे वर्णन करा",
            voiceTitle1: "खुलून बोला आणि ते गुप्तपणे सिद्ध करा",
            cardTitle: "गुप्तपणे नात्याचे वर्णन करा",
            low: "कमी",
            high: "जास्त",
            medium: "मध्यम",
            hold: "दाबा & ओरडा"
        },
        bluff: {
            title: "फिरवा आणि माझ्यासाठी अनामिकपणे ब्लफ विषय मिळवा",
            cardTitle: "माझ्याबद्दल ब्लफ करा",
            cardTitle2: "अनामिकपणे",
            cardPlaceholder: "याबद्दल ब्लफ लिहा",
            congo: "अभिनंदन",
            money: "पैसा",
            love: "प्रेम",
            lifestyle: "जीवनशैली",
            celebrity: "सेलिब्रिटी",
            funny: "मजेदार",
            savage: "सॅवेज",
            richLife: "श्रीमंत जीवन"
        },
        challenge: {
            title: "गुप्तपणे एक आव्हान लिहा",
            challenge: "आव्हान",
            placeholder: "एक आव्हान लिहा…"
        },
        hellheaven: {
            title: "त्यांचे स्वर्ग किंवा नरक ठरवण्यासाठी याचे उत्तर द्या — अनामिकपणे",
            hell: "नरक",
            heaven: "स्वर्ग",
            no: "नाही",
            yes: "होय",
            cardTitle: "त्यांच्याबद्दल काहीतरी लिहा…"
        },
        reputation: {
            low: "कमी",
            average: "सरासरी",
            good: "चांगली",
            high: "उच्च",
            veryhigh: "अत्यंत उच्च",
        },
        completePopup: {
            sent: "पाठवले!",
            neverMiss: "कडून कोणताही उत्तर चुकवू नका",
            peopleTap: "लोकांनी आधीच संदेश पाठवला आहे",
            getOwnMessage: "तुमची लिंक मिळवा 🔗",
            sendAnother: "आणखी एक संदेश पाठवा",
            newAppFrom: "Prankster अॅप वापरून पाहा",
            nointertoast: "कृपया इंटरनेट कनेक्शन चालू करा!",
        }
    },
    ta: {
        enterHints: "உங்களைப் பற்றி சில குறிப்புகள் எழுதுங்கள்",
        typeHints: "தட்டச்சு செய்யுங்கள்",
        uploadtitle: "உங்கள் செல்பி குறிப்பைச் சேர்க்கவும்",
        uploaddes1: "உங்கள் முக புகைப்படத்தை பதிவேற்றவும்",
        uploaddes2: "படத்தின் அளவு 5 MB வரை",
        popupTitle: "முக புகைப்படத்தை பதிவேற்றவும்",
        cameraPermission: "கேமரா அணுகல் மறுக்கப்பட்டது.",
        cameraMSG: "தயவுசெய்து உங்கள் முகத்தை படம் எடுங்கள்",
        galleryMSG: "தயவுசெய்து உங்கள் முகத்தைச் சேர்க்கவும்",
        sizeError: "படத்தின் அளவு 5MB-ஐ மீறுகிறது. சிறிய படத்தை தேர்ந்தெடுங்கள்.",
        detectionError: "படத்தில் முகம் கண்டறியப்படவில்லை. தெளிவான முகத்துடன் படம் பதிவேற்றவும்.",
        cancel: "ரத்து செய்",
        camera: "கேமரா",
        gallery: "கேலரி",
        avatar: "அவதார்",
        hinttext: "உரை குறிப்பு",
        hintimage: "செல்பி குறிப்பு",
        addselfie: "செல்பி சேர்க்கவும்",
        addImage: "படம் சேர்க்கவும்",
        selectRelation: "உறவை தேர்ந்தெடுங்கள்",
        cameraPermissionTitle: "கேமரா அனுமதி தேவை",
        cameraPermissionDesc: "உலாவி அமைப்புகளில் மைக்ரோஃபோன் அனுமதியை இயக்கவும்.",
        cameraBlockedAndroid: "கேமரா அனுமதி தடுக்கப்பட்டது. இயக்க:\n1. உலாவியில் மூன்று புள்ளிகளை (⋮) தட்டவும்\n2. தள அமைப்புகளுக்கு செல்லவும்\n3. கேமராவை தட்டவும்\n4. 'அனுமதி' தேர்ந்தெடுக்கவும்",
        cameraBlockedIOS: "கேமரா அனுமதி தடுக்கப்பட்டது. உலாவி அமைப்புகளில் இயக்கவும்.",
        cameraDenied: "கேமரா அணுகல் மறுக்கப்பட்டது",
        cameraNotSupported: "இந்த சாதனத்தில் கேமரா ஆதரிக்கப்படவில்லை.",
        galleryNotSupported: "இந்த சாதனத்தில் கோப்பு அணுகல் ஆதரிக்கப்படவில்லை.",
        steps: "இந்த படிகளை பின்பற்றவும்",
        cameraStep1: { text: "மூன்று புள்ளிகளை தட்டவும்", bold: "(⋮)", text2: "உலாவியில்" },
        cameraStep2: { text: "செல்லவும்", bold: "தள அமைப்புகள்", text2: "" },
        cameraStep3: { text: "அனுமதிக்கவும்", bold: "கேமரா", text2: "" },
        cameraStep4: { text: "பக்கம்", bold: "புதுப்பிக்கவும்", text2: "" },
        openInSafari: "Safari-ல் திறக்கவும்",
        safariStep1: "கீழே உள்ள பகிர் பொத்தானை (அம்புக்குறி பெட்டி) தட்டவும்",
        safariStep2: "உருட்டி \"Safari-ல் திறக்கவும்\" தட்டவும்",
        safariStep3: "மைக்ரோஃபோன் அணுகலை அனுமதிக்கவும்",
        openInChrome: "Chrome-ல் திறக்கவும்",
        chromeStep1: "மூன்று புள்ளிகள் (⋮) மெனுவை தட்டவும்",
        chromeStep2: "\"Chrome-ல் திறக்கவும்\" அல்லது \"உலாவியில் திறக்கவும்\" தேர்ந்தெடுக்கவும்",
        chromeStep3: "மைக்ரோஃபோன் அணுகலை அனுமதிக்கவும்",
        orCopyLink: "இணைப்பை நகலெடுத்து மற்ற உலாவியில் ஒட்டவும்",
        follow: "இந்த படிகளை பின்பற்றவும்",
        gotIt: "இணைப்பை நகலெடு",
        linkCopied: "இணைப்பு நகலெடுக்கப்பட்டது!",
        linkCopiedDesc: "இப்போது ஆப் உலாவியில் ஒட்டலாம்",
        microtitle: "இந்த உலாவி மைக்ரோஃபோனை ஆதரிக்கவில்லை",
        microErrorInstagram: "Instagram உலாவி மைக்ரோஃபோன் அணுகலை ஆதரிக்கவில்லை. Safari அல்லது Chrome-ல் திறக்கவும்.",
        microErrorSnapchat: "Snapchat உலாவி மைக்ரோஃபோன் அணுகலை ஆதரிக்கவில்லை. Safari அல்லது Chrome-ல் திறக்கவும்.",
        microErrorFacebook: "Facebook உலாவி மைக்ரோஃபோன் அணுகலை ஆதரிக்கவில்லை. Safari அல்லது Chrome-ல் திறக்கவும்.",
        microErrorTelegram: "Telegram உலாவி மைக்ரோஃபோன் அணுகலை ஆதரிக்கவில்லை. Safari அல்லது Chrome-ல் திறக்கவும்.",
        microErrorDefault: "இந்த ஆப் உலாவி மைக்ரோஃபோன் அணுகலை ஆதரிக்கவில்லை.",
        contentApiFail: "உள்ளடக்கம் கிடைக்கவில்லை. மீண்டும் முயற்சிக்கவும்.",
        logoTitle: "அநாமதேய ரோஸ்டிங் கேம்",
        hintExamples: [
            "ஒரு பாராட்டு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "சிறந்த தரம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "என் வைப் ஒரு வார்த்தையில் தட்டச்சு செய்யுங்கள்",
            "என் ego அதிகரிக்கும் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "கொஞ்சம் குறிப்பு தாருங்கள்",
            "ஒரு துப்பு தட்டச்சு செய்யுங்கள்",
            "விருப்பமான உணவு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான பானம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான இனிப்பு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிக விந்தையான உணவு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான திரைப்படம்/தொடர் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான பாடல் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான பாடகர்/இசைக்குழு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "கடைசியாக பார்த்த திரைப்படம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "இரகசிய க்ரஷ் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "பிரபலம் க்ரஷ் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "சிறந்த நண்பர் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான பொழுதுபோக்கு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான விளையாட்டு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான கேம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான சமூக ஊடக ID குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான புத்தகம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிகப்பெரிய பொய் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிக விந்தையான பழக்கம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிகவும் வேடிக்கையான பயம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிகவும் சங்கடமான தருணம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிக விந்தையான கனவு குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான நிறம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான கார் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான பைக் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான தொலைபேசி குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான இடம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "கனவு வேலை குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மறைமுக திறமை குறிப்பை தட்டச்சு செய்யுங்கள்",
            "தற்போதைய மனநிலை குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மக்களில் முதலில் என்ன கவனிக்கிறீர்கள் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "கடைசி DM குறிப்பை தட்டச்சு செய்யுங்கள்",
            "கடைசியாக Google தேடியது குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான emoji குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான கதாபாத்திரம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான influencer குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான உடை குறிப்பை தட்டச்சு செய்யுங்கள்",
            "விருப்பமான கார்ட்டூன் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "யாரை date செய்ய விரும்புகிறீர்கள் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "யாரை admire செய்கிறீர்கள் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "யார் உங்களை சிரிக்க வைக்கிறார்கள் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "இரகசிய உணர்வுகள் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "மிகவும் வேடிக்கையான விஷயம் குறிப்பை தட்டச்சு செய்யுங்கள்",
            "உங்கள் instagram ID தட்டச்சு செய்யுங்கள்",
            "உங்கள் tiktok ID தட்டச்சு செய்யுங்கள்",
            "உங்கள் snapchat ID தட்டச்சு செய்யுங்கள்"
        ],
        relations: {
            friend: "நண்பர்",
            family: "குடும்பம்",
            girlfriend: "காதலி",
            boyfriend: "காதலன்",
            enemy: "எதிரி",
            stranger: "அந்நியர்"
        },
        common: {
            next: "அடுத்து",
            send: "அனுப்பு",
            clear: "அழி",
            done: "முடிந்தது",
            skip: "தவிர்",
            save: "சேமிக்கவும்",
            edit: "திருத்தவும்",
            previous: "முந்தையது",
            claim: "கோரு",
            que: "கேள்வி:",
            nointertoast: "இணைய இணைப்பை இயக்கவும்!",
            apiFail: "கோரிக்கை தோல்வியடைந்தது. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்!",
            badWordWarning: "அவமதிப்பான மொழி அனுமதிக்கப்படாது",
        },
        noData: {
            title: "ஓ! நீங்கள் தடுக்கப்பட்டீர்கள்",
            description: "நீங்கள் தேடும் உள்ளடக்கம் கிடைக்கவில்லை.",
            oops: "அச்சச்சோ...",
            nointer: "இணைய இணைப்பு இல்லை!",
            nointerDes: "இணைய இணைப்பை இயக்கவும்!"
        },
        notAllowed: {
            title: "ஓ! வரம்பு முடிந்தது",
            description: "இன்று இந்த வகையின் வரம்பை அடைந்தீர்கள்.",
        },
        noData2: {
            title: "தரவு எதுவும் கிடைக்கவில்லை.",
            description: "கோரிக்கை தோல்வியடைந்தது! சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
            nointerDes: "இணைய இணைப்பை இயக்கவும்!"
        }, rotate: {
            title: "தயவு செய்து உங்கள் தொலைபேசியை திருப்புங்கள்",
            description: "இந்த ஆப் portrait mode-ல் சிறப்பாக வேலை செய்கிறது",
        },
        apiFail: {
            title: "தரவு எதுவும் கிடைக்கவில்லை!",
            description: "கோரிக்கை தோல்வியடைந்தது! சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்."
        },
        pauseLink: {
            title: "இணைப்பு இடைநிறுத்தப்பட்டது!",
            description: "இந்த இணைப்பு தற்காலிகமாக இடைநிறுத்தப்பட்டது. பின்னர் முயற்சிக்கவும்."
        },
        whoTalkin: {
            speakWords1: "இந்த வார்த்தையை உங்கள்",
            speakWords2: "குரலில் அநாமதேயமாக சொல்லுங்கள்",
            loading: "ஏற்றுகிறது...",
            defaultQuestion: "உங்கள் குரலை அநாமதேயமாக அனுப்புங்கள்!",
            defaultWord: "புனைப்பெயர்",
            recordError: "பதிவு மிகவும் குறுகியது. பதிவேற்றுவதற்கு முன் குறைந்தது 1 வினாடி பதிவு செய்யவும்.",
            unableError: "மைக்ரோஃபோன் அணுகல் கிடைக்கவில்லை. அனுமதிகளை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
            denied: "மைக்ரோஃபோன் அனுமதி மறுக்கப்பட்டது.",
            deniedIos: "மைக்ரோஃபோன் அணுகல் மறுக்கப்பட்டது. பக்கத்தை புதுப்பிக்கவும்.",
            playingError: "ஆடியோ இயக்குவதில் பிழை. மீண்டும் பதிவு செய்யவும்.",
            startError: "ஆடியோ தொடங்க play பொத்தானை தட்டவும்.",
            cancel: "ரத்து செய்",
            apiFail: "கோரிக்கை தோல்வியடைந்தது. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்!",
            micPermissionTitle: "மைக்ரோஃபோன் அனுமதி மறுக்கப்பட்டது",
            micPermissionDesc: "உலாவி அமைப்பில் மைக்ரோஃபோன் அனுமதியை இயக்கவும்.",
            steps: "இந்த படிகளை பின்பற்றவும்",
            step1: { text: "கிளிக் செய்யவும்", bold: "(⋮)", text2: "மேல் வலது பக்கம்" },
            step2: { text: "திறக்கவும்", bold: "அமைப்புகள் > தள அமைப்புகள்", text2: "" },
            step3: { text: "அனுமதிக்கவும்", bold: "மைக்ரோஃபோன்", text2: "" },
            step4: { text: "பக்கம்", bold: "புதுப்பிக்கவும்", text2: "" },
            ios1: { text: "தட்டவும்", bold: "அல்லது", text2: "கீழ் இடது பக்கம்" },
            ios2: { text: "தட்டவும்", bold: "(...)", text2: "" },
            ios3: { text: "அனுமதிக்கவும்", bold: "மைக்ரோஃபோன்", text2: "" },
            ios4: { text: "பக்கம்", bold: "புதுப்பிக்கவும்", text2: "" },
            close: "முடிந்தது"
        },
        picRoast: {
            entercomment: "இந்த புகைப்படத்தில் ஒரு நகைச்சுவையான கருத்தை அநாமதேயமாக பகிரவும்",
            entercomment2: "இந்த வீடியோவில் ஒரு நகைச்சுவையான கருத்தை அநாமதேயமாக பகிரவும்",
            loading: "ஏற்றுகிறது...",
            typeComment: "உங்கள் கருத்தை தட்டச்சு செய்யுங்கள்",
            defaultQuestion: "இந்த படத்திற்கு உங்கள் சிறந்த கருத்தை இடுங்கள்.",
        },
        annoyCard: {
            title: "இதைக் அனுப்பிய நண்பருக்காக ஒரு நகைச்சுவையான முகத்தைத் தேர்வு செய்யுங்கள்",
            subTitle: "உங்கள் நண்பரைப் பற்றிய உங்கள் எண்ணங்களை அடையாளம் தெரியாமல் பகிருங்கள்",
            typeNickname: "புனைப்பெயர் தட்டச்சு செய்யுங்கள்...",
            scratch: "கேள்விகளை திறக்க ஸ்கிராட்ச் செய்யுங்கள்",
            write: "அனுப்பியவருக்கு பதில் எழுதுங்கள்",
            writeAns: "பதில் தட்டச்சு செய்யுங்கள்",
            send: "அனுப்பு",
            here: "இங்கே கீறவும்",
            them: "அவர்களை தட்டச்சு செய்யுங்கள்",
            their: "அவர்களுடையது என்ன",
            addFace: "முகத்தை சேர்க்கவும்",
            nicknameLbl: "புனைப்பெயர்",
            editTitle: "உங்கள் கார்டை திருத்தவும்"
        },
        emotion: {
            text: "இந்த வார்த்தையை உணர்ச்சியுடன்",
            text2: "சொல்லுங்கள் அநாமதேயமாக",
            unableError: "மைக்ரோஃபோன் அணுகல் கிடைக்கவில்லை. அனுமதிகளை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
            cardTitle: "அவர்களைப் பற்றி நீங்கள் என்ன நினைக்கிறீர்கள்?",
            cardPlaceholder: "நீங்கள் உணரும்",
            defaultQuestion: "என் மனநிலையை யூகியுங்கள்",
            defaultWord: "OhYeahhhh",
            recordError: "பொத்தானை அழுத்திப் பிடிக்கவும்",
            angry: "கோபம்",
            happy: "மகிழ்ச்சி",
            love: "அன்பு",
            sad: "சோகம்",
        },
        hotness: {
            cardTitle: "நீங்கள் என்னைப் பற்றி என்ன நினைக்கிறீர்கள்?",
            cardPlaceholder: "ஏதாவது எழுதுங்கள்",
            defaultQuestion: "நான் இப்போது எப்படி தெரிகிறேன்?",
            spin: "சுழற்று",
            stop: "நிறுத்து",
        },
        roast: {
            roastTitle: "ரோஸ்ட்",
            textTitle: "பெயரில்லாமல் ரோஸ்ட் எழுதுங்கள்",
            voiceTitle: "பெயரில்லாமல் ரோஸ்ட் பேசுங்கள்",
            placeholder: "ரோஸ்ட் எழுதுங்கள்…",
            defaultQuestion: "என்னை அநாமதேயமாக ரோஸ்ட் செய்யுங்கள்",
        },
        confession: {
            textTitle1: "அநாமதேயமாக ஒரு வெளிப்பாட்டை எழுதுங்கள்",
            textTitle: "அநாமதேயமாக ஒரு கேள்வியை எழுதுங்கள்",
            title1: "அநாமதேயமாக வெளிப்பாட்டை கேளுங்கள்",
            title: "அநாமதேயமாக கேள்வியை கேளுங்கள்",
            defaultQuestion: "உங்கள் குரலை அநாமதேயமாக அனுப்புங்கள்!",
            recordError: "பதிவு மிகவும் குறுகியது. குறைந்தது 1 வினாடி பதிவு செய்யவும்.",
            unableError: "மைக்ரோஃபோன் அணுகல் கிடைக்கவில்லை. அனுமதிகளை சரிபார்க்கவும்.",
            denied: "மைக்ரோஃபோன் அணுகல் மறுக்கப்பட்டது. இந்த இணைப்பை தொலைபேசி உலாவியில் (Safari/Chrome) திறக்கவும்.",
            playingError: "ஆடியோ இயக்குவதில் பிழை. மீண்டும் பதிவு செய்யவும்.",
            startError: "ஆடியோ தொடங்க play பொத்தானை தட்டவும்.",
            typeComment: "உங்களை தட்டச்சு செய்யுங்கள்",
        },
        friend: {
            title: "ஒரு உறவைத் தேர்ந்தெடுத்து பெயரில்லாமல்",
            placeholder: "உங்கள் உறவ விவரிக்கவும்",
            voiceTitle1: "திறந்த மனதுடன் சொல்லுங்கள் மற்றும் அதை பெயரில்லாமல் நிரூபிக்கவும்",
            cardTitle: "உறவை விவரிக்கவும்",
            low: "குறைவு",
            high: "அதிகம்",
            medium: "நடுத்தரம்",
            hold: "பிடித்துக்கொ கத்துங்கள்"
        },
        bluff: {
            title: "சுழற்றி என்னுடைய அநாமதேய ப்ளஃப் தலைப்பை பெறுங்கள்",
            cardTitle: "என்னைப் பற்றி ப்ளஃப் செய்யுங்கள்",
            cardTitle2: "அநாமதேயமாக",
            cardPlaceholder: "இதைப் பற்றி ப்ளஃப் எழுதுங்கள்",
            congo: "வாழ்த்துகள்",
            money: "பணம்",
            love: "அன்பு",
            lifestyle: "வாழ்க்கை முறை",
            celebrity: "பிரபலம்",
            funny: "வேடிக்கை",
            savage: "சேவேஜ்",
            richLife: "பணக்கார வாழ்க்கை"
        },
        challenge: {
            title: "பெயரில்லாமல் ஒரு சவாலை எழுதுங்கள்",
            challenge: "சவால்",
            placeholder: "ஒரு சவாலை எழுதுங்கள்…"
        },
        hellheaven: {
            title: "அவர்கள் சொர்க்கமா அல்லது நரகமா என்பதைத் தீர்மானிக்க, அநாமதேயமாக இதற்குப் பதிலளிக்கவும்.",
            hell: "நரகம்",
            heaven: "சொர்க்கம்",
            no: "இல்லை",
            yes: "ஆம்",
            cardTitle: "அவர்களைப் பற்றி ஏதாவது எழுதுங்கள்…"
        },
        reputation: {
            low: "குறைவு",
            average: "சராசரி",
            good: "நல்லது",
            high: "உயர்",
            veryhigh: "மிக உயர்ந்த",
        },
        completePopup: {
            sent: "அனுப்பப்பட்டது!",
            neverMiss: "இடமிருந்து எந்த பதிலையும் தவறவிடாதீர்கள்",
            peopleTap: "நபர்கள் ஏற்கனவே செய்தி அனுப்பினார்கள்",
            getOwnMessage: "உங்கள் சொந்த இணைப்பை பெறுங்கள் 🔗",
            sendAnother: "மற்றொரு செய்தி அனுப்புங்கள்",
            newAppFrom: "Prankster ஆப்பை முயற்சிக்கவும்",
            nointertoast: "இணைய இணைப்பை இயக்கவும்!",
        }
    },
}